import {useRef} from 'react';

import {OptionsType, composePath, useNavigate} from 'shared/web';

export type NavigateWithoutBlocker = {
  (delta: number): void;
  <Path extends string>(path: Path, options?: OptionsType<Path>): void;
};

export function useNavigateWithoutBlocker() {
  const navigate = useNavigate();
  const shouldNavigateWithoutBlockerRef = useRef<boolean>(false);

  const navigateWithoutBlocker: NavigateWithoutBlocker = (
    pathOrDelta: string | number,
    options?: OptionsType<string>
  ) => {
    shouldNavigateWithoutBlockerRef.current = true;
    try {
      if (typeof pathOrDelta === 'number') {
        navigate(pathOrDelta);
      } else {
        navigate(composePath(pathOrDelta, options));
      }
    } finally {
      shouldNavigateWithoutBlockerRef.current = false;
    }
  };

  return {navigateWithoutBlocker, shouldNavigateWithoutBlockerRef};
}
